import React from "react";
import { Route, Routes } from "react-router-dom";
import LoginPage from "../pages/LoginPage";
import Home from "../pages/Home";
import FilterDetail from "../pages/FilterDetail";
import TSID_Redirect from "../pages/TSID_Redirect";
import RecoveryPassword from "../pages/RecoveryPassword";
import PresentationPage from "../pages/PresentationPage";
// import NotFoundPage from './pages/NotFoundPage';
import { LicenseInfo } from "@mui/x-license";
import ProtectedRoute from "./ProtectedRoute";
import { AuthProvider } from "./AuthProvider";

const AppRouter: React.FC = () => {
  LicenseInfo.setLicenseKey(
    "f62c231f4def6bd97a381b170a2196abTz0xMTU5MTAsRT0xNzgzNzI3OTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI="
  );
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/:logout?" element={<LoginPage />} />
        <Route path="/home" element={<Home />} />
        <Route path="/presentationPage" element={<PresentationPage />} />
        <Route path="/TSID_Redirect" element={<TSID_Redirect />} />
        <Route
          path="/filter/:id/:idObject?"
          element={
            <ProtectedRoute>
              <FilterDetail />
            </ProtectedRoute>
          }
        />
        <Route path="/password_change/:user" element={<RecoveryPassword />} />
        {/* <Route path="/home" element={<HomePage />} />
        <Route path="*" element={<NotFoundPage />} /> */}
      </Routes>
    </AuthProvider>
  );
};

export default AppRouter;
